import { ArrowUpOnSquareIcon, ChartBarIcon, SparklesIcon } from '@heroicons/react/24/outline';

const HowItWorks = () => {
  return (
    <section id="how-it-works" className="w-full mt-24">
      <div className="w-full bg-slate-50/90 py-24 md:py-32">
        <div className="mx-auto w-full max-w-6xl px-4 sm:px-8 md:px-12 text-center">
          <h2 className="text-3xl font-bold tracking-tight text-slate-900 sm:text-4xl md:text-5xl">How it Works</h2>
          <p className="mt-3 text-base text-slate-600 md:text-lg">Three simple steps to optimize your event pricing</p>

          <div className="mt-14 grid gap-8 sm:grid-cols-3">
            {/* Step 1 */}
            <div className="how-card rounded-3xl border border-slate-200 bg-white p-14 text-center shadow-lg min-h-[360px]">
              <div
                className="mx-auto inline-flex h-20 w-20 items-center justify-center rounded-full text-white shadow"
                style={{
                  backgroundImage:
                    'linear-gradient(135deg, var(--color-primary), color-mix(in oklch, var(--color-primary) 65%, var(--color-accent)))'
                }}
              >
                <span className="text-xl font-bold">1</span>
              </div>
              <ArrowUpOnSquareIcon className="mx-auto mt-12 mb-4 h-12 w-12 text-[color:var(--color-primary)]" />
              <h4 className="mt-8 text-lg font-semibold text-slate-900">Upload your menu</h4>
              <p className="mx-auto mt-5 max-w-sm text-base leading-relaxed text-slate-600">
                Drop in a PDF or image of your beverage menu.
              </p>
            </div>

            {/* Step 2 */}
            <div className="how-card rounded-3xl border border-slate-200 bg-white p-14 text-center shadow-lg min-h-[360px]">
              <div
                className="mx-auto inline-flex h-20 w-20 items-center justify-center rounded-full text-white shadow"
                style={{
                  backgroundImage:
                    'linear-gradient(135deg, var(--color-primary), color-mix(in oklch, var(--color-primary) 65%, var(--color-accent)))'
                }}
              >
                <span className="text-xl font-bold">2</span>
              </div>
              <SparklesIcon className="mx-auto mt-12 mb-4 h-12 w-12 text-[color:var(--color-primary)]" />
              <h4 className="mt-8 text-lg font-semibold text-slate-900">AI analyzes pricing</h4>
              <p className="mx-auto mt-5 max-w-sm text-base leading-relaxed text-slate-600">
                Our AI extracts items and prices, then benchmarks against thousands of events.
              </p>
            </div>

            {/* Step 3 */}
            <div className="how-card rounded-3xl border border-slate-200 bg-white p-14 text-center shadow-lg min-h-[360px]">
              <div
                className="mx-auto inline-flex h-20 w-20 items-center justify-center rounded-full text-white shadow"
                style={{
                  backgroundImage:
                    'linear-gradient(135deg, var(--color-primary), color-mix(in oklch, var(--color-primary) 65%, var(--color-accent)))'
                }}
              >
                <span className="text-xl font-bold">3</span>
              </div>
              <ChartBarIcon className="mx-auto mt-12 mb-4 h-12 w-12 text-[color:var(--color-primary)]" />
              <h4 className="mt-8 text-lg font-semibold text-slate-900">Get recommendations</h4>
              <p className="mx-auto mt-5 max-w-sm text-base leading-relaxed text-slate-600">
                Receive a detailed report with pricing insights and specific recommendations.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default HowItWorks;
